import { Head, usePage } from '@inertiajs/react';

import { FeaturedProductsSection } from './components/FeaturedProductsSection';
import { CategoryRailSection } from './components/CategoryRailSection';
import { CollectionsShowcaseSection } from './components/CollectionsShowcaseSection';
import { HeroSection } from './components/HeroSection';
import { NewsletterSection } from './components/NewsletterSection';

export default function HomeIndex() {
    const {
        categories = [],
        heroSlides = [],
        newArrivals = [],
        selectedCollections = {},
        theme3InitLoad = {},
    } = usePage().props;

    const brand = theme3InitLoad.brand ?? {};
    const media = theme3InitLoad.media ?? {};
    const siteTitle = brand.shortName || brand.title || brand.name || 'Captex';

    const heroPrimary = heroSlides[0] || {};
    const heroSecondary = heroSlides[1] || heroSlides[0] || {};
    const heroImageOne = heroPrimary.image || media.heroImageOne || '';
    const heroImageTwo = heroSecondary.image || media.heroImageTwo || '';

    const featuredProducts = [
        ...(selectedCollections.cap_people_love?.products || []),
        ...newArrivals,
    ]
        .filter(Boolean)
        .slice(0, 6);

    const collectionCards = categories
        .filter(Boolean)
        .slice(0, 8)
        .map((category, index) => ({
            id: category.id ?? index,
            title: category.title || category.name || 'Collection',
            subtitle: category.subtitle || 'Alpona collection',
            description:
                category.description ||
                `Explore ${category.title || category.name || 'this'} from the live catalog.`,
            image:
                category.image ||
                category.imageUrl ||
                category.coverImage ||
                media.featuredFallbackImage ||
                '',
            productCount: category.products ?? category.productCount ?? 0,
            href: category.slug ? `/collections/${category.slug}` : '/collections',
        }));

    return (
        <>
            <Head>
                <title>{siteTitle}</title>
                <meta
                    name="description"
                    content="Fresh beauty products, soft editorial shopping, and warm curated collections built for theme 3."
                />
            </Head>

            <main className="space-y-10">
                <HeroSection
                    heroPrimary={heroPrimary}
                    heroSecondary={heroSecondary}
                    heroImageOne={heroImageOne}
                    heroImageTwo={heroImageTwo}
                />

                <FeaturedProductsSection featuredProducts={featuredProducts} />

                <CategoryRailSection
                    title="Shop by category"
                    subtitle="Curated categories"
                    categories={collectionCards.slice(0, 4)}
                    ctaHref="/collections"
                    ctaLabel="Explore Categories"
                    accent="pink"
                />

                <CategoryRailSection
                    title="More to browse"
                    subtitle="Fresh category picks"
                    categories={collectionCards.slice(4, 8)}
                    ctaHref="/collections"
                    ctaLabel="See More"
                    accent="rose"
                />

                <CollectionsShowcaseSection collectionCards={collectionCards} />

                <NewsletterSection />
            </main>
        </>
    );
}
